var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageSetup != null)?_c('div',{staticClass:"about-social"},[_c('aboutSocialCorp'),_c('aboutSocialCivil')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }